import type {FC} from 'react';

import styles from './PagesContainer.module.css';
import Home from '../Pages/Home/Home';
import HowItWorks from '../Pages/HowItWorks/HowItWorks';
import FAQ from '../Pages/FAQ/FAQ';
import QualifyingDevices from '../Pages/QualifyingDevices/QualifyingDevices';
import ContactUsWithRecaptcha from '../Pages/ContactUs/ContactUsWithRecaptcha';
import TermsAndConditions from '../Pages/TermsAndConditions/TermsAndConditions';
import Promo from '../Pages/Promo/Promo';

interface PagesContainerProps {
    isPromotionActive: any;
    isDisabled: boolean;
}

const PagesContainer: FC<PagesContainerProps> = ({isPromotionActive, isDisabled}) => {
    let className = '';
    if (isPromotionActive) {
        className = styles.PagesContainer;
    } else {
        className = styles.PagesContainerBgGray;
    }

    if (isPromotionActive === null) {
        return (
            <div className={`${styles.loadingSpinner} m-auto`}></div>
        );

    }
    if (isPromotionActive) {
        return (
            <div className={className} data-testid="PagesContainer">
                <div className={`${styles.PageWrapper} p-0 py-4 p-md-8`}>
                    <Home/>
                    <HowItWorks/>
                    <QualifyingDevices/>
                    <FAQ/>
                    <ContactUsWithRecaptcha/>
                    <TermsAndConditions/>
                </div>
            </div>
        );

    } else {
        return (
            <div className={className} data-testid="PagesContainer">
                <div className={`${styles.PageWrapper} p-0 py-4 p-md-8`}>
                    <Promo/>
                    <FAQ/>
                    <ContactUsWithRecaptcha/>
                    <TermsAndConditions/>
                </div>
            </div>
        );
    }


}

export default PagesContainer;